export default __webpack_public_path__ + "media/images/svg/instagram-social-a2fc03b888dcc2da6b962a6ee32f4a4a.svg";